import { Link } from "wouter";
import { Logo } from "./Logo";
import { ExternalLink } from "./ExternalLink";
import { SOPHIE_URL } from "@/lib/sophie-url";
import { SITE } from "@/lib/site-info";

export function SiteFooter() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link href="/" className="footer-logo" aria-label="Taidō — home">
              <Logo variant="primary-white" height={32} />
            </Link>
            <p className="footer-tagline">
              <span className="footer-tagline-name">
                <span className="ftn-serif">
                  Taid<em>ō</em>
                </span>{" "}
                <span className="ftn-kanji">(道)</span>{" "}
                <span className="ftn-coral">
                  — the way of technology and AI.
                </span>
              </span>
              <span className="footer-tagline-desc">
                We design, build, and operate AI platforms, business
                solutions, and process automation for regulated Australian
                service organisations.
              </span>
            </p>
            <p className="address">
              {SITE.address.line1}
              <br />
              {SITE.address.line2}
              <br />
              {SITE.address.line3}
              <br />
              {SITE.address.line4}
            </p>
          </div>
          <nav aria-label="What we do">
            <h2>What we do</h2>
            <ul>
              <li>
                <ExternalLink href={SOPHIE_URL}>Sophie Platform</ExternalLink>
              </li>
              <li><Link href="/what-we-do/ai-data/">AI + Data</Link></li>
              <li><Link href="/what-we-do/d365/">D365 Solutions</Link></li>
              <li><Link href="/what-we-do/automation/">Process Automation</Link></li>
              <li><Link href="/what-we-do/upliftx/">UpliftX Advisory</Link></li>
            </ul>
          </nav>
          <nav aria-label="Industries">
            <h2>Industries</h2>
            <ul>
              <li><Link href="/industries/aged-care/">Aged Care</Link></li>
              <li><Link href="/industries/healthcare/">Healthcare</Link></li>
              <li><Link href="/industries/ndis/">NDIS / Disability</Link></li>
              <li><Link href="/industries/education/">Education</Link></li>
              <li><Link href="/industries/government/">Government</Link></li>
              <li><Link href="/industries/financial-services/">Financial Services</Link></li>
            </ul>
          </nav>
          <nav aria-label="Company">
            <h2>Company</h2>
            <ul>
              <li><Link href="/about/">About us</Link></li>
              <li><Link href="/our-name/">Our name</Link></li>
              <li><Link href="/news/">News</Link></li>
              <li><Link href="/contact/">Contact</Link></li>
              <li><Link href="/privacy/">Privacy Policy</Link></li>
              <li><Link href="/terms/">Terms &amp; Conditions</Link></li>
            </ul>
          </nav>
        </div>
        <div className="footer-bottom">
          <span>© {SITE.legalName} 2026. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
